<ion-header>
  <ion-toolbar color="light">
    <ion-title>Publish Targets</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- Loading state -->
  <div *ngIf="isLoading" class="loading-container">
    <ion-progress-bar type="indeterminate"></ion-progress-bar>
    <p class="loading-text">Summarizing content for each platform...</p>

    <div *ngIf="shouldShowSocialCardPreview" class="overlay-image-skeleton" style="margin:12px 0;">
      <ion-item color="light">
        <ion-label>
          <ion-skeleton-text [animated]="true" style="width: 60%;"></ion-skeleton-text>
        </ion-label>
      </ion-item>
      <ion-card>
        <ion-card-content>
          <!-- Use ion-skeleton-text to mimic the ion-img area -->
          <ion-skeleton-text [animated]="true" style="display:block; width:100%; height:200px;"></ion-skeleton-text>
        </ion-card-content>
      </ion-card>
    </div>

    <div *ngFor="let target of targets">
      <ion-item color="light">
        <ion-avatar slot="start" class="small-avatar">
          <img [src]="'assets/icon/publish-targets/' + target.id + '.png'" />
        </ion-avatar>
        <ion-label>
          <ion-skeleton-text [animated]="true" style="width: 80%;"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" style="width: 60%;"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" style="width: 30%;"></ion-skeleton-text>
        </ion-label>
      </ion-item>
    </div>
  </div>

  <!-- Summaries -->
  <div *ngIf="!isLoading">
    <!-- Social Card preview-->
    <div *ngIf="shouldShowSocialCardPreview()" class="overlay-image">
      <ion-item color="light">
        <ion-label>Generated Image From Template</ion-label>
        <ion-button slot="end" fill="clear" (click)="rebuildSocialCardImage()">
          <ion-icon slot="icon-only" name="refresh-outline"></ion-icon>
        </ion-button>
      </ion-item>
      <div>
      <app-edit-social-card
        [post]="post"
      ></app-edit-social-card>
      </div>         
    </div>
    <div *ngIf="!shouldShowSocialCardPreview() && selectedImage">
      <ion-item color="light">
        <ion-label>Selected Image</ion-label>
      </ion-item>
      <div class="selected-image">
        <ion-img [src]="selectedImage" [alt]="post?.title"></ion-img>
      </div>
    </div>

    <div *ngFor="let target of results" class="target-section">
      <!-- Display platform header -->
      <ion-item color="light" class="target-header" lines="none">
        <ion-avatar slot="start" class="small-avatar">
          <img [src]="'assets/icon/publish-targets/' + target.id + '.png'" />
        </ion-avatar>
        <ion-label>{{ target.name }}</ion-label>
      </ion-item>

      <!-- Informational warning for Instagram when no image is available -->
      <ion-item color="light" *ngIf="target.id === 'instagram' && !hasImageAvailable()" class="warning-item">
        <ion-icon name="warning" slot="start" color="warning"></ion-icon>
        <ion-label class="ion-text-wrap" color="warning">
          Instagram will not be published because no image is present.
        </ion-label>
      </ion-item>

      <!-- Target-specific loading state -->
      <div *ngIf="loadingStates[target.id]" class="loading-container">
        <ion-progress-bar type="indeterminate"></ion-progress-bar>
        <p class="loading-text">Re-summarizing content for {{ target.name }}. Please wait...</p>
      </div>

      <!-- Cards for each post -->
      <div *ngIf="!loadingStates[target.id]">
        <ion-card *ngFor="let post of target.posts; let i = index; trackBy: trackByIndex">
          <ion-card-content (click)="startEditing(target.id, i)">
            <div *ngIf="!isEditing(target.id, i)">
              <p>{{ post.text }}</p>
              <p *ngIf="post.generatedLink">{{ post.generatedLink }}</p>
            </div>
            <ion-textarea label="Editing..." labelPlacement="stacked" *ngIf="isEditing(target.id, i)"
              [(ngModel)]="editState[target.id][i]" (ngModelChange)="handleEditChange(target.id, i)" spellcheck="true"
              autocorrect="on" [autoGrow]="true" fill="solid">
            </ion-textarea>
          </ion-card-content>

          <!-- Editing controls -->
          <ion-toolbar *ngIf="isEditing(target.id, i)">
            <ion-buttons slot="start">
              <ion-button color="danger" (click)="deletePost(target.id, i)">
                <ion-icon slot="start" name="trash-outline"></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-text *ngIf="target.characterLimit" slot="end" [color]="getCharacterCountColor(target, i)"
              class="character-count small-text" class="character-count">
              {{
              (editState[target.id]?.[i]?.length || target.posts[i]?.text.length || 0)
              + (target.posts[i]?.generatedLink?.length ? target.posts[i]?.generatedLink.length + 1 : 0)
              }}/{{ target.characterLimit || '∞' }}
            </ion-text>
            <ion-buttons slot="end">
              <ion-button color="danger" (click)="cancelEdit(target.id, i)">
                <ion-icon slot="start" name="close-circle-outline"></ion-icon>
                Cancel
              </ion-button>
              <ion-button color="success" (click)="saveEdit(target.id, i)" [disabled]="isOverCharacterLimit(target, i)">
                <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
                Save
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-card>
      </div>

      <!-- Error handling -->
      <ion-item color="danger" lines="none" *ngIf="target.error">
        <ion-label>{{ target.error }}</ion-label>
      </ion-item>

      <!-- Action buttons -->
      <ion-toolbar color="default" *ngIf="!isTargetBeingEdited(target.id)" class="target-actions">
        <ion-buttons slot="start">
          <ion-button color="secondary" (click)="originalSummary(target)">
            <ion-icon slot="start" name="arrow-undo-circle-outline"></ion-icon>
            <span>Original</span>
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <div *ngIf="target.ai" slot="end" class="ai-indicator">
            <ion-icon src="assets/icon/menu/dark/smart-toy.svg"></ion-icon>
            <span class="desktop-only">AI Generated</span>
          </div>
          <ion-button color="secondary" (click)="redoSummary(target)">
            <ion-icon slot="start" name="refresh-circle-outline"></ion-icon>
            AI Redo
          </ion-button>
          <ion-button *ngIf="!target.accepted" fill="solid" [color]="acceptColor(target)"
            [disabled]="allowAccept(target)" (click)="acceptSummary(target)">
            <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
            Accept
          </ion-button>
          <ion-button *ngIf="target.accepted" fill="outline" color="success" disabled="true">
            <ion-icon slot="start" name="checkmark-done-circle-outline"></ion-icon>
            Accepted
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </div>

    <!-- Accept All button -->
    <ion-footer>
      <ion-toolbar>
        <ion-item color="danger" lines="none" *ngIf="hasErrors()">
          <ion-label>Please fix errors above.</ion-label>
        </ion-item>
        <ion-button expand="full" color="success" [disabled]="hasErrors()" (click)="acceptAll()">
          <ion-icon slot="start" src="assets/icon/menu/dark/send.svg"></ion-icon>
          Publish Now
        </ion-button>
      </ion-toolbar>
    </ion-footer>
  </div>
</ion-content>